import React, { useEffect, useState, useRef }  from 'react';
import { connect } from 'react-redux';
import AccountsOrders from '../ui-componets/accounts-orders';
import CategoriesDropdown from "../ui-componets/dropdown";
import BreadCrumbs from "../ui-componets/breadcrumbs";
import {getOrders, updateOrdersDuration} from "../modules/ui.ducks";
import Loader from '../ui-componets/loader';
import Back from "../ui-componets/Back";
import { useTranslation } from 'react-i18next';
import { useTokenAuth } from '../hooks/useTokenAuth';


interface IProps {
    getOrders:any
    ordersHistory:any
    updateOrdersDuration: any
    duration: any
    history: any
    tokenDetails: any
    global: any
    isOrderFetching: boolean
    isUserFetching: boolean
    countryInfo: any
    loginDetails: any
    shopUser?: boolean
    dieselCardUser?: boolean
}

function Orders(props:IProps) {
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(true);
    const isMountedRef = useRef(true);

    const SortByOptions = [
        {
            id: 'Last_30_Days',
            text: t('Last 30 Days'),
            value: 'Last_30_Days',
        },
        {
            id: 'Last_3_Months',
            text: t('Last 3 Months'),
            value: 'Last_3_Months'
        },
        {
            id: 'Last_Year',
            text: t('Last Year'),
            value: 'Last_Year',
        }
    ];
  
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Use reusable token authentication hook
    useTokenAuth('/profile/orders', props.global, props.tokenDetails, props.history);

    const [dropDownValue, setDropDownValue] = useState();
    const { getOrders, ordersHistory, updateOrdersDuration, duration, tokenDetails, isOrderFetching, isUserFetching, countryInfo} = props;
    const sections = [
        { key: 'Home', content: t('Your Account'), className: 'parent-breadcrumbs font-styleLight', href: '/account', link: true },
        { key: 'Orders', className: 'child-breadcrumbs font-styleLight', content: t('Your Orders'), link: false },
    ]

    const handleChange = (data: any) =>{
        // Prevent state updates if component is unmounted
        if (!isMountedRef.current) return;
        
        setDropDownValue(data.id);
         let durationValue = 30;
         if(data.id === "Last_30_Days"){
            durationValue = 30
         } else if(data.id === "Last_3_Months"){
            durationValue = 90
         } else if(data.id === "Last_Year"){
            durationValue = 365
         } 
         updateOrdersDuration(durationValue);
    }

    useEffect(()=>{
        // Set mounted flag
        isMountedRef.current = true;
        
        // Only call getOrders if component is still mounted
        if (isMountedRef.current) {
            getOrders();
        }
        
        const timer = setTimeout(() => {
            if (isMountedRef.current) {
                safeSetState(setIsLoader, false);
            }
        }, 2000);

        // Cleanup function
        return () => {
            isMountedRef.current = false;
            clearTimeout(timer);
        };
    },[duration, tokenDetails])

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    // Prevent any state updates after unmount
    const safeSetState = (setter: React.Dispatch<React.SetStateAction<any>>, value: any) => {
        if (isMountedRef.current) {
            setter(value);
        }
    };

    return (
        <div>
              { isUserFetching || isOrderFetching || isOrderFetching === undefined ?
            <div>
                <Loader/>
            </div>:
        <div className="parent-order order-pb">
            <div className="set-pref pt-5">
                {
                    props.shopUser && <div className="dropdown-for-activity dropdown-for-order pt-0 pl-5">
                        <Back
                            refreshToken={props.tokenDetails.refresh_token}
                            dieselCardUser={props.dieselCardUser}/>
                    </div>
                }
                <div className="page-heads-title-for-all-accounts">
                    <div className="page-heads-title-for-all-accounts-img">
                        <img src="/profile/static/orders.svg" />
                    </div>
                    <div className="page-heads-title-for-all-accounts-content">
                        <p className="m-0 font-styleBold">{t('Your Orders')}</p>
                    </div>
                    {sections.length > 0 && !props.shopUser ? <BreadCrumbs
                        sections={sections}
                        handleClick={(url: string) => props.history.push(url)}
                        backAction={() => props.history.goBack()} />
                        : null}
                </div>
                <div className="dropdown-for-activity dropdown-for-order">
                    <div className="dropdown-for-activity-sub-binder dropdown-for-order-sub-binder">
                        <p className="m-0 fornt-styleBold">{t('Show')}</p>
                    </div>
                    <div className="dropdown-for-activity-componet dropdown-for-order-componet">
                    <CategoriesDropdown
                                automationId=""
                                label=""
                                dropdownOptions={SortByOptions}
                                defaultOption={SortByOptions.find(item => item.value === dropDownValue) || SortByOptions[0]}
                                onInputChange={data => handleChange(data)}
                            />
                    </div>
                </div>
            <div className="your-orders">
            {ordersHistory && ordersHistory.map((item:any)=>  
                <AccountsOrders
                orderData={item}
                refreshToken={props.tokenDetails?.refresh_token}
                shopUser={props.shopUser}
                onlyDashboard={props.loginDetails?.onlyDashboard}
                countryInfo={countryInfo}
                />
            ) }
            </div>
            </div>
        </div>
    }
        </div>
    );
}
const mapStateToProps = (state: any) => ({
    duration: state.ui.ordersDuration,
    ordersHistory: state.ui.ordersHistory,
    tokenDetails: state.join.tokens,
    global: state.global,
    isOrderFetching: state.ui.isOrderFetching,
    isUserFetching: state.ui.isUserFetching,
    countryInfo : state.ui.countryDetails,
    loginDetails : state.join.loginDetails,
});

export default connect(mapStateToProps, { getOrders, updateOrdersDuration})(Orders);
